import { ForceTab } from "slotworks/debug/menu/tabs/force-tab";

export class AgsForceTab extends ForceTab {
    protected formatForceData(inputText: string) {
        return inputText;
    }
}
